import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Lightbulb, Wand2, Send, Loader2 } from "lucide-react";
import { dropSummary } from "./previewModel";

export const PreviewGuidance = ({ guidance, run, busy, onApply }) => {
  const [note, setNote] = useState("");
  const [applying, setApplying] = useState(null);
  const drops = dropSummary(run?.dropReasons);
  const apply = async (suggestions, freeText) => {
    setApplying(suggestions[0]?.id || "note");
    try { await onApply(suggestions, freeText); } finally { setApplying(null); }
  };
  return (
    <div className="rounded-xl border border-amber-500/20 bg-amber-500/[0.05] p-5 space-y-4" data-testid="preview-guidance">
      <div className="flex items-start gap-3">
        <Lightbulb className="h-5 w-5 text-amber-300 mt-0.5 flex-shrink-0" />
        <div className="min-w-0">
          <p className="text-amber-200 text-sm font-medium" data-testid="preview-guidance-question">{guidance.question}</p>
          {guidance.hint && <p className="text-gray-400 text-xs mt-1" data-testid="preview-guidance-hint">{guidance.hint}</p>}
          {drops.length > 0 && <p className="text-gray-500 text-[11px] mt-1" data-testid="preview-drop-summary">Rejected on the way: {drops.join(" · ")}</p>}
        </div>
      </div>
      <div className="grid gap-2 sm:grid-cols-2" data-testid="preview-guidance-suggestions">
        {(guidance.suggestions || []).map((s) => (
          <button key={s.id} onClick={() => apply([s])} disabled={busy || !!applying}
            className="text-left rounded-lg border border-white/10 bg-white/[0.03] hover:border-ism-teal/40 hover:bg-ism-teal/[0.06] px-3 py-2.5 transition-colors disabled:opacity-50"
            data-testid={`preview-suggestion-${s.id}`}>
            <p className="text-sm text-white flex items-center gap-2">{applying === s.id ? <Loader2 className="h-3.5 w-3.5 animate-spin text-ism-teal" /> : <Wand2 className="h-3.5 w-3.5 text-ism-teal" />}{s.label}</p>
            {s.reason && <p className="text-[11px] text-gray-500 mt-0.5">{s.reason}</p>}
          </button>
        ))}
      </div>
      <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); if (note.trim()) { apply([], note.trim()); setNote(""); } }}>
        <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Or tell me in your words — e.g. 'regional banks, not insurers; the buyer is the COO'"
          className="flex-1 bg-white/[0.04] border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder:text-gray-600 focus:outline-none focus:border-ism-teal/50"
          data-testid="preview-guidance-note-input" />
        <Button type="submit" size="sm" disabled={busy || !!applying || !note.trim()} className="bg-ism-teal hover:bg-ism-teal/90 text-black rounded-lg" data-testid="preview-guidance-note-submit">
          {applying === "note" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        </Button>
      </form>
    </div>
  );
};
